import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants/constants";
import { getCurrentToken } from "../helpers/helpers";

export const AnalyticsApi = createApi({
    reducerPath: "analytics",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            headers.set("Content-type", "application/json");
            headers.set("authorization", `Bearer ${getCurrentToken()}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getEventAnalytics: builder.query({
            query: (eventId) => ({
                url: `api/analytics/event/${eventId}`,
                method: "GET",
            }),
        }),
        getAttendeeHistory: builder.query({
            query: (userId) => ({
                url: `api/analytics/attendee/${userId}`,
                method: "GET",
            }),
        }),
        getRatios: builder.query({
            query: ({ groupBy, eventId }) => ({
                url: `api/analytics/ratios`,
                method: "GET",
                params: {
                    groupBy,
                    ...(eventId && { eventId }),
                },
            }),
        }),
        getCompanyAnalytics: builder.query({
            query: ({ page = 1, limit = 20, sortField, sortOrder } = {}) => ({
                url: `api/analytics/company`,
                method: "GET",
                params: {
                    page,
                    limit,
                    ...(sortField && { sortField }),
                    ...(sortOrder && { sortOrder }),
                },
            }),
        }),
        getEventComparison: builder.query({
            query: (eventIds) => ({
                // eventIds should be a comma-separated string like 'id1,id2,id3'
                url: `api/analytics/compare`,
                method: "GET",
                params: {
                    events: eventIds,
                },
            }),
        }),
        getJobTitlesAnalytics: builder.query({
            query: ({ eventId }) => ({
                url: `api/analytics/job-titles`,
                method: "GET",
                params: {
                    ...(eventId && { eventId }),
                },
            }),
        }),
    }),
});

export const {
    useGetEventAnalyticsQuery,
    useGetAttendeeHistoryQuery,
    useGetRatiosQuery,
    useGetCompanyAnalyticsQuery,
    useGetEventComparisonQuery,
    useGetJobTitlesAnalyticsQuery,
    useLazyGetEventAnalyticsQuery,
    useLazyGetAttendeeHistoryQuery,
    useLazyGetRatiosQuery,
    useLazyGetCompanyAnalyticsQuery,
    useLazyGetEventComparisonQuery,
    useLazyGetJobTitlesAnalyticsQuery,
} = AnalyticsApi;
